import { useState } from "react";
import { Reveal } from "@/components/site/Reveal";
import { SectionLabel, AudienceToggle, PlanCards, SubpageBanner } from "@/components/att/ATTShared";

export default function ATTPlansPage() {
  const [tab, setTab] = useState("residential");
  return (
    <div className="py-14 md:py-20" data-testid="att-plans-page">
      <div className="max-w-7xl mx-auto px-6 md:px-12 space-y-10">
        <Reveal>
          <SubpageBanner src="/att/og-plans.jpg" alt="AT&T unlimited wireless plans" testid="att-plans-banner" />
        </Reveal>
        <Reveal>
          <div className="flex flex-wrap items-end justify-between gap-5">
            <div>
              <SectionLabel>Wireless Plans</SectionLabel>
              <h1 className="mt-4 font-serif-display text-4xl sm:text-5xl font-bold tracking-tight text-[#1d2329]">Wireless plans &amp; pricing.</h1>
            </div>
            <AudienceToggle value={tab} onChange={setTab} />
          </div>
        </Reveal>
        <PlanCards audience={tab} />
      </div>
    </div>
  );
}
